/* Search bar upgrade (2026-10-04): example searches in the placeholder, "/" shortcut,
   voice search, and a sticky header once the page scrolls past it.
   Works alongside plx-search.js, which owns the dropdown; voice input reaches it via an 'input' event. */
(function () {
  var hdr = document.querySelector('.plh2');
  var input = document.querySelector('[data-plxs-input]');
  if (!hdr || !input || !input.form) return;
  var form = input.form;
  var base = input.getAttribute('placeholder');

  /* ---------- example searches ---------- */
  var hints = ['Try “4m x 3m”', 'Try “EPDM pond liner”', 'Try “12ft x 10ft”', 'Try “pond pump”', 'Try “underlay”', 'Try “liner kit”', 'Try “blanket weed”'];
  var hi = 0, rot;
  function idle() { return document.activeElement !== input && !input.value; }
  function tick() { if (idle()) input.setAttribute('placeholder', hints[hi++ % hints.length]); }
  function startRot() { clearInterval(rot); rot = setInterval(tick, 3200); }
  input.addEventListener('focus', function () { clearInterval(rot); input.setAttribute('placeholder', base); });
  input.addEventListener('blur', function () { if (!input.value) startRot(); });
  setTimeout(function () { tick(); startRot(); }, 2500);

  /* ---------- "/" focuses the search ---------- */
  var kbd = form.querySelector('.plxsb-kbd');
  function kbdShow() { if (kbd) kbd.hidden = !idle(); }
  ['input', 'focus', 'blur'].forEach(function (ev) { input.addEventListener(ev, kbdShow); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target, tag = t && t.tagName;
    if (t && (t.isContentEditable || tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT')) return;
    e.preventDefault();
    input.focus();
  });

  /* ---------- voice search ---------- */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  var mic = form.querySelector('[data-plxsb-mic]');
  function spoken(t) {
    return t
      .replace(/(\d+(?:\.\d+)?)\s*(?:metres?|meters?|m)\b/gi, '$1m')
      .replace(/(\d+(?:\.\d+)?)\s*(?:feet|foot|ft)\b/gi, '$1ft')
      .replace(/\s+(?:by|times)\s+/gi, ' x ')
      .replace(/[.?!]+$/, '');
  }
  if (SR && mic) {
    mic.hidden = false;
    var rec = null;
    function done() {
      rec = null;
      mic.classList.remove('is-listening');
      mic.setAttribute('aria-pressed', 'false');
      input.setAttribute('placeholder', base);
    }
    mic.addEventListener('click', function () {
      if (rec) { rec.stop(); return; }
      rec = new SR();
      rec.lang = 'en-GB';
      rec.interimResults = true;
      rec.maxAlternatives = 1;
      rec.onstart = function () {
        mic.classList.add('is-listening');
        mic.setAttribute('aria-pressed', 'true');
        clearInterval(rot);
        input.setAttribute('placeholder', 'Listening… say a size or product');
      };
      rec.onresult = function (ev) {
        var t = '';
        for (var i = 0; i < ev.results.length; i++) t += ev.results[i][0].transcript;
        input.value = spoken(t.trim());
        input.dispatchEvent(new Event('input', { bubbles: true }));
        kbdShow();
      };
      rec.onerror = done;
      rec.onend = done;
      try { rec.start(); } catch (e) { done(); }
    });
  }

  /* ---------- sticky header ---------- */
  var sec = hdr.parentElement, T = 0, stuck = false, lastW = window.innerWidth;
  function measure() {
    if (stuck) return;
    var b = hdr.getBoundingClientRect().bottom;
    var nav = document.querySelector('.plxn');
    if (nav && nav.offsetParent) b = Math.max(b, nav.getBoundingClientRect().bottom);
    T = b + window.scrollY + 40;
  }
  function unstick() { hdr.classList.remove('is-stuck'); sec.style.minHeight = ''; stuck = false; }
  function onScroll() {
    var y = window.scrollY;
    if (!stuck && y > T) {
      sec.style.minHeight = sec.offsetHeight + 'px';
      hdr.classList.add('is-stuck');
      stuck = true;
    } else if (stuck && y < T - 40) unstick();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return; // phone address-bar show/hide only changes height
    lastW = window.innerWidth;
    if (stuck) unstick();
    measure();
    onScroll();
  });
  window.addEventListener('load', function () { measure(); onScroll(); });
  measure();
  onScroll();
})();
